import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import createDebug from 'debug'
// devtools needs to be imported before vue, and is stripped from the prod build
import devtools from '@vue/devtools'
import Vue from 'vue'

import { sleep } from '@shared/utils'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import { i18n, loadLanguageAsync } from '@/i18n-setup'
import { queryParamsToObj } from '@/utils'
import { initTwitchExtHelper } from './twitch-ext'
import { initAPI } from './api'
import './vue-setup'
import '@/assets/scss/index.scss'

const { NODE_ENV, IS_PROD, COMMIT_HASH } = process.env

if (process.env.NODE_ENV === 'development') {
    // can't call devtools.connect() unconditionally. The extension
    // is loaded in multiple windows at the same time. If they all
    // call connect(), shit breaks.
    window.devtools = devtools
}

Sentry.init({
    dsn: 'https://839480221b8b49c0bb640987b95bcd03@o364658.ingest.sentry.io/4871419',
    enabled: true,
    environment: NODE_ENV,
    release: COMMIT_HASH,
    blacklistUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome(?:-extension)?:\/\//i,
        /moz-extension:\/\//i,
        /safari-extension:\/\//i
    ],
})

dayjs.extend(duration)
dayjs.extend(relativeTime)
dayjs.extend(isSameOrAfter)
dayjs.extend(utc)

window.ga = window.ga || (() => {}) // no-op in dev
window.debug = createDebug('sbox')
window.cl = console.log
window.jsonCopy = obj => JSON.parse(JSON.stringify(obj))
window.cljson = obj => cl(jsonCopy(obj))
// The twitch helper js should be loaded before this file.
// Appears only in the dev rig log
window.tl = window.Twitch.ext.rig.log
window.GUANZO_CHANNEL_ID = '23435553'
window.sleep = sleep

loadLanguageAsync(queryParamsToObj()?.language)
initTwitchExtHelper()
initAPI()

const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

window.app = app // for debugging
